import React, {useState, Fragment,} from 'react';
import { Card, CardContent,Chip,Typography, } from '@mui/material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { TablaPersonalizada } from 'components';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import DetalleDeLaEmpresa from './detalle';
import { obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';
import DetalleDeLosMediosAlternativos from './detalle/DetalleDeLosMediosAlternativos';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import IndicadorDeCarga from 'components/IndicadorDeCarga';

const ListadoDeMedios = ({ openFullScreenDialog, handleClose, datosDelMedio, datosDeLasEmpresas, listadoDeRegistrosDeMedios}) => {

  const dispatch = useDispatch();
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const [catalogoDeMediosPublicos] = useState("catalogoDeMediosPublicos");
  const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
  const [mostrarDetalleDeLaEmpresa, setMostrarDetalleDeLaEmpresa] = useState(false);
  const [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({});
  const [datosDelMedioSeleccionado, setDatosDelMedioSeleccionado] = useState([]);
  const [datosDelQRMovil, setDatosDelQRMovil] = useState({});
  const [mostrarDetalleMediosAlternativos, setMostrarDetalleMediosAlternativos] = useState(false);
  const {tipoDeMedioDeComunicacion, cobertura} = datosDelMedio;

  const [encabezadoTabla] = useState([
      { title: 'Nit', field: 'nit_empresa', cellStyle:{ maxWidth: '80px' }},
      { title: 'Nombre', field: 'nombre', cellStyle:{ maxWidth: '80px' }},
      { title: 'descripcion', field: 'detallesDeMedioDeComunicacion.descripcion'},
      { title: "Estado", field: 'usuarioSidi',
      render: rowData=><div style={{minWidth: '120px'}}>
          {
              (<Chip label={rowData?.habilitado ? "Habilitado" : "Deshabilitado"} color="primary" />)
          }
          </div>
      },
      { title: 'Acciones', field: 'accion',
      render: rowData=><div style={{minWidth: '100px'}}>
          {
              (<div>
                  <TooltipPersonalizado title="Ver detalle del medio" handleFunction={() => mostrarMediosDeLaEmpresa(rowData)} icon={"visibility"} fontSize={30} />
              </div>)
          }
          </div>
      },
  ]);

  const obtenerDetalleDelMedio = async (rowData) => {

    setcargandoSolicitud(true);
    ServiciosDelAPI[catalogoDeMediosPublicos].setearMetodoPublico(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: catalogoDeMediosPublicos,
        saveInStore: false,
        nombreDelMetodo: `listar/detalleDeEmpresas/${rowData.nit_empresa}/${tipoDeMedioDeComunicacion.id}/${rowData?.id || ""}` ,
    }));

    setcargandoSolicitud(false);
    if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || 'No se pudó obtener los datos', true, );
    if(respuesta?.data?.length === 0) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este medio', true, );
    if(!respuesta?.data) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este medio', true, );

    setDatosDelMedioSeleccionado(respuesta?.data)
    setDatosDelQRMovil({...rowData})
    setMostrarDetalleMediosAlternativos(true);
  }

  const mostrarMediosDeLaEmpresa = async (rowData) => {
    if(tipoDeMedioDeComunicacion?.id >= 4 || tipoDeMedioDeComunicacion <= 6){ return obtenerDetalleDelMedio(rowData); }
    setDatosGeneralesDelTarifario(rowData)
    setMostrarDetalleDeLaEmpresa(true);
  }

  const cerrarModal = () => { setMostrarDetalleDeLaEmpresa(false); }
  const cerrarModalMediosAlternativos = () => { setMostrarDetalleMediosAlternativos(false); }

  const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,});

    const { errorType, messageType, openResponse} = responseData;

    return (
      <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={"Empresas registradas"}
        fullscreen={true}
      >
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <Typography variant="h4" style={{textAlign: "center"}}>{tipoDeMedioDeComunicacion?.descripcion || ""} - {cobertura?.descripcion || ""} </Typography>
                <CardContent>
                  <TablaPersonalizada
                      data={listadoDeRegistrosDeMedios}
                      title={"Listado de medios de la empresa"}
                      header={encabezadoTabla}
                      refreshList={undefined}
                      addRegister={undefined}
                  />
                </CardContent>
            </Card>

            {mostrarDetalleDeLaEmpresa && (
              <DetalleDeLaEmpresa
                  openFullScreenDialog={mostrarDetalleDeLaEmpresa}
                  handleClose={cerrarModal}
                  title={"Detalle de la empresa"}
                  datosDelMedio={datosDelMedio}
                  datosDeLasEmpresas={datosDeLasEmpresas}
                  datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                  tipoDelMedio={"television"}
              />
            )}
            {mostrarDetalleMediosAlternativos && (
              <DetalleDeLosMediosAlternativos
                  openFullScreenDialog={mostrarDetalleMediosAlternativos}
                  handleClose={cerrarModalMediosAlternativos}
                  title={"Detalle de la empresa"}
                  datosDelMedio={datosDelMedio}
                  datosDelMedioSeleccionado={datosDelMedioSeleccionado}
                  tipoDelMedio={"television"}
                  datosDelQRMovil={datosDelQRMovil}
              />
            )}
        </Fragment>
      </DialogoPantallaCompleta>
    );
}

export default ListadoDeMedios;